import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Container from '../../component/Container';
import IconSelector from '../IconSelector';
import styles from './index.scss';

const linkTextClasses = classNames({
    [styles.linkText]: true,
});
const SupportAndServices = ({ data, header }) => (
    <Container>
        <div name="support" />
        <div className={styles.container}>
            <h2 className={styles.header}>{header}</h2>
            <div>
                {data.map((linkGroup, i) => (
                    <div className={styles.linkGroup} key={i}>
                        <h3 className={styles.groupName}>{linkGroup.name}</h3>
                        <div className={styles.links}>
                            {linkGroup.links.map((link, j) => (
                                <span className={styles.link} key={j}>
                                    <IconSelector linkIcon={link.linkIcon} />
                                    <a
                                        className={linkTextClasses}
                                        href={link.url}
                                        data-item-name={link.linkLabelTag}
                                        data-group-name={linkGroup.nameTag}
                                    >
                                        {link.linkLabel}
                                    </a>
                                </span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </Container>
);

SupportAndServices.propTypes = {
    data: PropTypes.array.isRequired,
    header: PropTypes.string.isRequired,
};

export default SupportAndServices;
